<template>
  <div class="myCarousel">

    <el-carousel :interval="5000" :height="windowWidth <= 768 ? '480px':windowHeight +'px'" arrow="always" class="slider">
      <el-carousel-item v-for="(item,index) in bannerList" :key="index" class="slider_box">
        
        <el-image
          style="width: 100%; height: 100%"
          :src="item.picUrl"
          fit="cover"
        ></el-image>

      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { bannerList } from "@/api/menu/index.js";
export default {
  data() {
    return {
      autoHeight: null,
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      bannerList:[],
      queryParams: {
       picType:"home"
      },
    };
  },
  mounted() {
    this.getBannerList()
    let that = this;
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        window.fullWidth = document.documentElement.clientWidth;
        if(window.fullWidth < 768){
            that.windowHeight = 480; // 高
        }else{
            that.windowHeight = window.fullHeight; // 高
        }
        that.windowWidth = window.fullWidth; // 宽
      })();
    };
  },
  methods: {
    getBannerList(){
      bannerList(this.queryParams).then(res =>{
        this.bannerList = res.rows
      })
    }
  },
};
</script>

<style lang="less" scoped>
// .myCarousel{
//     width: 100%;
//     height: 100vh;
// }
.slider {
  width: 100%;
  max-height: 100vh;
//   background: red;
}
</style>>
